<template>
  <section>
    <div class="row" v-if="title">
      <div class="col-xs-12">
        <h3>Lista de espera - {{ title }}</h3>
      </div>
    </div>
    <div class="row" v-if="carregando">
      <div class="col-xs-12 datatable-spinner text-center">
        <font-awesome-icon :icon="'spinner'" spin />
      </div>
    </div>
    <div class="row" v-if="!carregando && items.length">
      <div class="col-xs-12">
        <DataTable
          :fields="fields"
          :slots="['gravidade']"
          :dados="dados"
          :carregando="carregando"
        >
          <template slot="header-actions">
            <ExportCSV :dados="dados" :tipo="'espera'" />
          </template>
          <ExportCSV :dados="dados" />
          <template slot="gravidade" slot-scope="props">
            <div
              :class="[getGravidadeClass(props.rowData.gravidade), 'gravidade']"
            >
              {{ props.rowData.gravidade }}
            </div>
          </template>
        </DataTable>
      </div>
    </div>
    <div class="row" v-if="!carregando && !items.length">
      <div class="col-xs-12 nenhum-item">
        <p>Nenhum item encontrado</p>
      </div>
    </div>
  </section>
</template>

<script>
import { getGravidadeClass, fields } from './datatableFields'
import { NoApiTable as DataTable } from '../common'
import ExportCSV from './ExportCSV'

export default {
  components: {
    DataTable,
    ExportCSV
  },
  props: {
    title: {
      type: String,
      default: ''
    },
    chave: {
      type: String,
      default: ''
    },
    items: {
      type: Array,
      default: () => []
    },
    carregando: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      fields
    }
  },
  methods: {
    getGravidadeClass
  },
  computed: {
    dados() {
      return this.items
    }
  }
}
</script>

<style scoped src="./datatable.css"></style>



// WEBPACK FOOTER //
// src/components/ProcedimentosSaude/ListaFilaEspera.vue